// for guide on modularized apps look at https://dev.to/jack/organizing-your-react-app-into-modules-d6n
import Internal from './Internal';
import MtUmet from './MtUmet';
import Settings from './Settings';
import TenantLookup from './TenantLookup';
import TerminologyData from './TerminologyData';
import TranslationResources from './TranslationResources';
import UserManager from './UserManager';
import Workflows from './Workflows';

export default [
  MtUmet,
  TranslationResources,
  TerminologyData,
  Workflows,
  UserManager,
  TenantLookup,
  Settings,
  Internal,
];
